

import { ref } from 'vue';

// 定义一个响应式变量来存储当前时间戳
const currentTimestamp = ref(0);

// 封装获取当前时间戳的方法
const getCurrentTimestamp = () => {
  return Math.floor(Date.now() / 1000); // 转换为秒
};

// 更新当前时间戳
const updateTimestamp = () => {
  currentTimestamp.value = getCurrentTimestamp();
};

// 初始化时获取时间戳
updateTimestamp();

// 导出 getCurrentTimestamp 方法
export { getCurrentTimestamp };



